import { styled } from '@mui/material/styles';
import Radio from '@mui/material/Radio';

const StyledRadioRoot = styled(Radio)({
  '&:hover': {
    backgroundColor: 'transparent',
  },
});

const RadioIcon = styled('span')({
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: '#f5f8fa',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
  },
});

const RadioCheckedIcon = styled(RadioIcon)({
  backgroundColor: 'currentColor',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: 'currentColor',
  },
});

// Inspired by blueprintjs
interface StyledRadioProps {
  value: string;
  color: 'primary' | 'secondary' | 'default';
}

export default function StyledRadio(props: StyledRadioProps) {
  return <StyledRadioRoot disableRipple checkedIcon={<RadioCheckedIcon />} icon={<RadioIcon />} {...props} />;
}
